<template>
  <metainfo></metainfo>

  <div class="page-body">
    <div class="container-xl">
      <div class="spinner-border" role="status"></div>
    </div>
  </div>
</template>

<script>
import {useRouter} from "vue-router/dist/vue-router"
import {defineComponent} from "vue"
import {useMeta} from "vue-meta"

export default defineComponent({
  name: "Index",
  setup() {
    useMeta({title: "Главная HPanel"})

    const router = useRouter()

    router.push({name: "Channels"})
  }
})
</script>

<style scoped>

</style>
